module.exports = __webpack_public_path__ + "img/banana-bran-muffins.f847447f.jpg";